<template>
    <JsonSchemaPhoneForm v-if="form.schema.format === 'phone'" v-bind="propsWithListenerAttrs" disable-auto-format>
        <template #icon>
            <slot name="icon" />
        </template>
    </JsonSchemaPhoneForm>
    <JsonSchemaEmailForm v-else-if="form.schema.format === 'email'" v-bind="propsWithListenerAttrs">
        <template #icon>
            <slot name="icon" />
        </template>
    </JsonSchemaEmailForm>
    <JsonSchemaDateForm
        v-else-if="form.schema.format === 'date'"
        v-bind="propsWithListenerAttrs"
        show-invalid-date
    >
        <template #icon>
            <slot name="icon" />
        </template>
    </JsonSchemaDateForm>
    <JsonSchemaTextForm v-else v-bind="propsWithListenerAttrs">
        <template #icon>
            <slot name="icon" />
        </template>
    </JsonSchemaTextForm>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { FormElement } from '@evidentid/dashboard-commons/components/Form';
    import AbstractJsonSchemaForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/AbstractJsonSchemaForm';
    import JsonSchemaDateForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaDateForm.vue';
    import JsonSchemaEmailForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaEmailForm.vue';
    import JsonSchemaPhoneForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaPhoneForm.vue';
    import JsonSchemaTextForm
        from '@evidentid/dashboard-commons/components/JsonSchemaForm/elements/JsonSchemaTextForm.vue';
    import { JsonFormBase } from '@evidentid/json-schema/interfaces/JsonForm';
    import { JsonSchemaString } from '@evidentid/json-schema/interfaces/JsonSchema';

    @Component({
        components: { JsonSchemaEmailForm, JsonSchemaDateForm, JsonSchemaTextForm, JsonSchemaPhoneForm, FormElement },
        inheritAttrs: false,
    })
    export default class BulkImportStringField extends AbstractJsonSchemaForm<JsonFormBase<JsonSchemaString>, string> {
    }
</script>
